import React from 'react'

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="">
			<div className="has-text-centered m-4 has-text-link is-size-6 is-size-7-touch">
				
					Copyright &copy; {currentYear} {' '}
					<a href="https://michaelgkroth.com">MGK Technology Solutions, LLC </a>
				
			</div>
		</footer>
	);
}

export default Footer